import {
    FETCH_LOAD_SUBTASK_BASED_AUTO_TEMPLATE_REQUEST,
    FETCH_LOAD_SUBTASK_BASED_AUTO_TEMPLATE_SUCCESS,
    FETCH_LOAD_SUBTASK_BASED_AUTO_TEMPLATE_FALUIRE,
} from './loadSubtaskBasedOnAutoTemplateAndProjectTypes'

const initialState = {
  loading: false,
  subTaskBasedOnAutoTemplate: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_SUBTASK_BASED_AUTO_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_SUBTASK_BASED_AUTO_TEMPLATE_SUCCESS : 
    return {
      ...state,
      subTaskBasedOnAutoTemplate: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_SUBTASK_BASED_AUTO_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      subTaskBasedOnAutoTemplate: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
